import Vue from 'vue';
import Vuex from 'vuex';
import plugins from './plugins';
import modules from './modules';
import { getClientId, getAuthority, getRedirectUri, getEmailLoginDomain } from '@commons/office';

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		ie: 'default',
		mailRecover: '',
		isLogged: false,
		alunoMatricula: null,
		alunoCPF: '',
		alunoCidade: '',
		alunoDataNascimento: '',
		aceiteTermoDocumentos: false,
		isGrad: false,
		isPos: false,
		fatura: {},
		calouro: false,
		alertNotifications: [],
		popupNotifications: [],
		periodo: null,
		cursosNaoAceitos: '',
		cssCheckoutIE: null,
		msalConfig: {
			auth: {
				clientId: getClientId(),
				authority: getAuthority(),
				redirectUri: getRedirectUri()
			},
			cache: {
				cacheLocation: 'localStorage'
			}
		},
		accessToken: '',
		emailLoginDomain: getEmailLoginDomain(),
		sha256Hash: async function (message) {
			const encoder = new TextEncoder();
			const data = encoder.encode(message);
			const hashBuffer = await crypto.subtle.digest('SHA-256', data);
			const hashArray = Array.from(new Uint8Array(hashBuffer));
			const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
			return hashHex;
		},
		textToSlug(text) {
			if (typeof text !== 'string') return; 

			return text
				.toLowerCase()
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '')
				.replace(/[^a-z0-9\s-]/g, '')
				.trim()
				.replace(/\s+/g, '_')
				.replace(/-+/g, '_');
		}
	},
	plugins,
	mutations: {
		setcssCheckoutIE(state, value) {
			state.cssCheckoutIE = value
		},
		setCursosNaoAceitos(state, value) {
			state.cursosNaoAceitos = value;
		},
		setIE(state, value) {
			state.ie = value;
		},
		setMailRecover(state, value) {
			state.mailRecover = value;
		},
		setAlunoMatricula(state, matricula) {
			state.alunoMatricula = matricula;
		},
		setAlunoCidade(state, cidade) {
			state.alunoCidade = cidade;
		},
		setAlunoCPF(state, cpf) {
			state.alunoCPF = cpf;
		},
		setAlunoDataNascimento(state, dataNascimento) {
			state.alunoDataNascimento = dataNascimento;
		},
		setAceiteTermoDocumentos(state, aceite) {
			state.aceiteTermoDocumentos = aceite;
		},
		setNivelDeEnsino(state, nivelEnsino) {
			switch (parseInt(nivelEnsino)) {
				case 1:
					state.isGrad = true;
					state.isPos = false;
					break;

				case 2:
					state.isGrad = false;
					state.isPos = true;
					break;

				default:
					state.isGrad = false;
					state.isPos = false;
					break;
			}
		},
		setFatura(state, fatura) {
			state.fatura = fatura;
		},
		setCalouro(state, calouro) {
			state.calouro = calouro;
		},
		setAlertNotifications(state, alertNotifications) {
			state.alertNotifications = alertNotifications;
		},
		setPopupNotifications(state, popupNotifications) {
			state.popupNotifications = popupNotifications;
		},
		setPeriodo(state, periodo) {
			state.periodo = periodo;
		},
	},
	modules
});

export default store;
